// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b1b1fa7f","234":"a709a477","348":"af51c31e","389":"923d4d1c","423":"d1a9c3ea","486":"c25aa91b","608":"5f102e35","831":"c78e5928","915":"1d50a248"}[chunkId] + ".chunk.js";
};